import mapboxgl from 'mapbox-gl'

import storeImg from '~/assets/new_gofind/markerPin.svg'
import pinCustomColor from './PinCustom'
import { segmentTagHtml } from '~/components/SegmentTag'
import getSegmentationPin from './SegmentationPin'

export function createStoreMarker(
  map,
  store,
  segmentation,
  onClick,
  setStoreHover,
  customerThemeConfig
) {
  const { coordinates } = store
  const markerElement = new Maker(store, segmentation, customerThemeConfig).make(
    onClick,
    setStoreHover
  )
  const marker = new mapboxgl.Marker(markerElement)
    .setLngLat(coordinates?.latlon?.split(',')?.reverse())
    .addTo(map)

  return marker
}

class Maker {
  constructor(store, segmentation, customerThemeConfig) {
    this._store = store
    this._customerThemeConfig = customerThemeConfig
    this._segmentation = segmentation
  }

  make(onClick, setStoreHover) {
    return this._createWrapper(onClick, setStoreHover)
  }

  _createWrapper(onClick, setStoreHover) {
    const wrapper = document.createElement('div')
    wrapper.classList.add('gofind-map-store')
    wrapper.id = `map-store-${this._store.cnpj}`
    wrapper.appendChild(this._createPinImage())
    wrapper.appendChild(this._createTitle())
    wrapper.appendChild(this._createPulse())
    wrapper.appendChild(this._createShadow())
    wrapper.addEventListener('click', () => onClick(this._store))
    wrapper.addEventListener('mouseover', setStoreHover)

    return wrapper
  }

  _createPinImage() {
    switch (this._customerThemeConfig?.pointMarker) {
      case 'simple':
        return this._createSVGElement()
      case 'personalization':
        return this._createImgElement()
      case 'storeSegmentation':
        return this._createSegmentationSVGElement()
      default:
        return this._createDefaultImageElement()
    }
  }

  _createSVGElement() {
    const pinCustomSvg = pinCustomColor(
      this._customerThemeConfig.colorAction,
      this._customerThemeConfig.typePointMarker
    )

    const svg = document.createElement('section')
    svg.innerHTML = `${pinCustomSvg}`

    return svg
  }

  _createImgElement() {
    const image = document.createElement('img')
    image.src = this._customerThemeConfig.imageIconSvg
    image.alt = this._store?.name

    return image
  }

  _createSegmentationSVGElement() {
    const primaryColor = this._customerThemeConfig.colorAction
    const segment = this._store.segmentation
    const pinCustomSvg = getSegmentationPin(this._segmentation[segment]?.color || primaryColor)

    const svg = document.createElement('section')
    svg.innerHTML = `${pinCustomSvg}`

    return svg
  }

  _createDefaultImageElement() {
    const image = document.createElement('img')
    image.src = storeImg

    return image
  }

  _createTitle() {
    const storeName = this._getStoreName()
    const segment = this._segmentation[this._store.segmentation]
    const container = document.createElement('div')
    container.innerHTML = segmentTagHtml(storeName, segment)

    return container
  }

  _getStoreName() {
    const maxCharacter = 40
    let storeName = this._store?.name?.split('&#')[0]?.trim() || ''
    if (storeName.length > maxCharacter) storeName = storeName.slice(0, maxCharacter).concat('...')
    return storeName
  }

  _createPulse() {
    const pulse = document.createElement('div')
    pulse.classList.add('store-pulse')

    return pulse
  }

  _createShadow() {
    const shadow = document.createElement('div')
    shadow.classList.add('store-shadow')

    return shadow
  }
}
